
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/salespro-app-for-retailers",
      function () {
        return require("private-next-pages/salespro-app-for-retailers/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/salespro-app-for-retailers"])
      });
    }
  